import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useAuthStore } from '../../store/authStore'
import { useNavigate } from 'react-router-dom'

export default function Login() {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0()
  const { user } = useAuthStore()
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoading)
      return
    if (isAuthenticated && user) {
      const path = user.user_type == 'creator'
        ? '/creator/dashboard' : '/brand/dashboard'
      navigate(path, {replace: true})
      return
    }
    if (!isAuthenticated)
      loginWithRedirect({appState: {
        returnTo: window.location.pathname}})
  }, [isAuthenticated, isLoading, user])

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-blue via-primary-purple to-primary-blue flex items-center justify-center px-4 py-8">
      <div className="max-w-lg w-full bg-white/95 backdrop-blur-lg rounded-3xl shadow-2xl p-8 text-center">
        <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Redirecting to login...</h2>
        <p className="text-gray-600">Please wait</p>
      </div>
    </div>
  )
}